import { Board } from '@ih/app/shared/apis/interfaces';

export class ShowDeleteConfirmation {
  public static readonly type = '[Project/Manager/List] ShowDeleteConfirmation';
  constructor(public readonly board: Board) {}
}
